import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import SetsAndItems from 'src/common/organisms/setsanditems/SetsAndItems';
import {
    OrderDetailMainContainer,
    SetsItemsCotainer,
} from 'src/pages/orders/components/orderDetails/orderDetailTab/OrderDetailTab.styled';
import { useTranslation } from 'react-i18next';
import { getTotalCount } from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ExtrasOrderDetail = ({
    toggleCard,
    extras,
    handleSetItemClick,
    ordersList,
}) => {
    const [extraItemLists, setExtraItemLists] = useState([]);
    const { t } = useTranslation();
    const { orderDetails } = useSelector((state) => state.orderSummaryReducer);

    useEffectWithErrorLogging(() => {
        if (orderDetails?.length > 0) {
            const extraItemDetails = orderDetails?.filter(
                (order) => order.isSet === false
            );
            setExtraItemLists(extraItemDetails);
        }
    }, [orderDetails]);

    const HeaderTitle =
        ordersList &&
        (ordersList?.currentOrderType === 'KE' ||
            ordersList?.currentOrderType === 'ZOR' ||
            ordersList?.currentOrderType === 'ZKA')
            ? `${t('ConsignmentAdd.submit.items')} (${
                  extraItemLists?.length ? extraItemLists.filter(
                    (d) =>
                        d?.status !==
                            'キャンセル' &&
                        d?.status?.toLowerCase() !==
                            'cancel'
                )?.length : 0
              })`
            : `${t('ConsignmentAdd.shipping.extraItems')} (${
                  getTotalCount(extraItemLists.filter(
                    (d) =>
                        d?.status !==
                            'キャンセル' &&
                        d?.status?.toLowerCase() !==
                            'cancel'
                ))
              })`;
    return (
        <>
            <CollapsableCard
                id="orders-extrasOrderDetail-extrasOrderDetail-extras"
                title={HeaderTitle}
                onClick={() => toggleCard('extras', !extras)}
                isExpanded={extras}
                padding={'0.8rem'}
                titleFontSize={'15px'}
                cursor={'pointer'}
            >
                {extras ? (
                    <>
                        <OrderDetailMainContainer
                            style={{ height: 'fit-content' }}
                        >
                            {extraItemLists?.length > 0 ? (
                                <>
                                    {extraItemLists.map((extraItem, index) => {
                                        const extra = {
                                            ...extraItem,
                                            id: extraItem.cfn,
                                            uom: extraItem.isSet
                                                ? t('common.setLabel')
                                                : extraItem.uom,
                                            orderType:
                                                ordersList &&
                                                ordersList?.currentOrderType
                                                    ? ordersList?.currentOrderType
                                                    : null,
                                        };

                                        return extraItem?.isBundleHeader &&
                                            extraItem.bundleItems ? ( 
                                            <SetsAndItems
                                                isBundle 
                                                isEquityOrder={true}
                                                isOrderDetail
                                                marginOnMediumDevice={
                                                    '0 0 15px 0'
                                                }
                                                marginOnLargeDevice={
                                                    '0 0 15px 0'
                                                }
                                                marginOnMobileDevice={'0'}
                                                key={index}
                                                subitem={true}
                                                minWidth={'10%'}
                                                width={'48.5%'}
                                                setOrItemDetails={extra}
                                                isCounterButton={false}
                                                cardType={'items'}
                                                showBrand={true}
                                                showType={true}
                                                // boxShadow="0px 0px 6px #74DED6"
                                                margin={'10px 3px'}
                                                setNameColor="#1010EB"
                                                setNameFontSizeMobile="15px"
                                                setNameFontSizeDesktop="15px"
                                                itemCardsContainerMinMobWidth={
                                                    '95%'
                                                }
                                                addfullBorder="1px solid #74DED6"
                                                // onSetItemClick={() =>
                                                //     handleBundleSetItemClick(
                                                //         item
                                                //     )
                                                // }
                                                clickable={true}
                                                childrenDetails={true}
                                                quickOrderFlag={false}
                                                setOrItemDetailsFontSizeDesktop={
                                                    '14px'
                                                }
                                                isClickable={false}
                                                style={{
                                                    height: 'fit-content',
                                                }}
                                            />
                                        ) : (
                                            <SetsItemsCotainer
                                                key={extraItem.cfn}
                                                style={{
                                                    height: 'fit-content',
                                                }}
                                            >
                                                <SetsAndItems
                                                    isOrderDetail
                                                    setOrItemDetails={extra}
                                                    isCounterButton={false}
                                                    isQuantity
                                                    alignSelfBrand={
                                                        'flex-start'
                                                    }
                                                    showBrand={true}
                                                    boxShadow={
                                                        '0px 0px 6px #00000029'
                                                    }
                                                    isEquityOrder={true}
                                                    isEquityNT={
                                                        extraItem.salesOrg ==
                                                        'S030'
                                                            ? false
                                                            : true
                                                    }
                                                    addfullBorder={
                                                        '1px solid #74DED6'
                                                    }
                                                    showStatus={
                                                        extraItem?.status
                                                            ? true
                                                            : false
                                                    }
                                                    showHome={
                                                        extraItem?.home
                                                            ? true
                                                            : false
                                                    }
                                                    marginOnMediumDevice={
                                                        '0 0 15px 0'
                                                    }
                                                    marginOnLargeDevice={
                                                        '0 0 15px 0'
                                                    }
                                                    margin={'0px 0px 10px 0px'}
                                                    setNameColor={'#1010EB'}
                                                    setNameFontSizeDesktop={
                                                        '15px'
                                                    }
                                                    setNameFontSizeMobile={
                                                        '15px'
                                                    }
                                                    onSetItemClick={
                                                        handleSetItemClick
                                                    }
                                                    setDescriptionMinWidth={
                                                        '0px'
                                                    }
                                                    clickable={true}
                                                    orderDetail={true}
                                                    orderType={
                                                        ordersList &&
                                                        ordersList?.currentOrderType
                                                            ? ordersList.currentOrderType
                                                            : null
                                                    }
                                                    isExtraItem 
                                                ></SetsAndItems>
                                            </SetsItemsCotainer>
                                        );
                                    })}
                                </>
                            ) : null}
                        </OrderDetailMainContainer>
                    </>
                ) : null}
            </CollapsableCard>
        </>
    );
};

export default ExtrasOrderDetail;
